const SafetyIconProtectiveGloves = ({
  className,
}: { className?: string } = {}) => (
  <svg
    className={className}
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="35"
      height="35"
      rx="17.5"
      fill="white"
    />
    <rect
      x="0.5"
      y="0.5"
      width="35"
      height="35"
      rx="17.5"
      stroke="#269D84"
    />
    <path
      d="M11.6672 17.2066C11.5757 20.0726 14.9506 23.6039 18.1171 24.7143M11.6672 17.2066C11.3473 17.7571 8.07235 20.3821 8.01447 21.4936C7.7377 23.7018 11.4883 27.8498 14.3813 27.9909C15.461 28.1445 16.9585 26.3279 18.477 24.9764C19.3137 24.2323 20.5186 24.0607 25.3426 22.8629C27.0938 22.5587 29.1974 19.538 26.0793 16.9792M11.6672 17.2066C12.6438 14.89 14.3318 10.4114 17.6446 8.64211C18.9885 7.87797 22.4823 7.17488 25.9057 10.4293C27.0832 11.4187 29.1238 13.589 27.2243 16.0888C25.9572 17.5655 24.0419 17.1382 23.8567 19.6916"
      stroke="#171717"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SafetyIconProtectiveGloves
